export default function uniquePeople(people: Office.EmailAddressDetails[]): Office.EmailAddressDetails[] {
  const email = 'emailAddress'
  const flags = []
  const output: Office.EmailAddressDetails[] = []

  for (let i: number = 0; i < people.length; i++) {
    if (!flags[people[i][email]]) {
      flags[people[i][email]] = true
      output.push(people[i])
    }
  }

  return output
}
